import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ContractDashboard from './pages/contract-dashboard';
import ContractDetails from './pages/contract-details';
import ContractEditor from './pages/contract-editor';
import DocumentManagement from './pages/document-management';
import MilestoneManagement from './pages/milestone-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ContractDashboard />} />
        <Route path="/contract-dashboard" element={<ContractDashboard />} />
        <Route path="/contract-details" element={<ContractDetails />} />
        <Route path="/contract-editor" element={<ContractEditor />} />
        <Route path="/document-management" element={<DocumentManagement />} />
        <Route path="/milestone-management" element={<MilestoneManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;